import React from "react";
import { Box, Paper, Grid, TextField, Typography } from "@mui/material";

type Props = {
  data: any;
  onChange: (newData: any) => void;
};

function PaperForm({ data, onChange }: Props) {
  const handleChange = (key: string, value: any) => {
    onChange({ ...data, [key]: value });
  };

  return (
    <Paper
      sx={{
        p: 3,
        mb: 3,
        borderRadius: 2,
        border: "1px solid #e0e0e0",
        backgroundColor: "#f8f9fa",
      }}
      variant="outlined"
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        sx={{ mb: 2 }}
      >
        <Typography variant="h6" fontWeight="bold" color="primary">
          Paper Configuration
        </Typography>
      </Box>

      <Grid container spacing={3} sx={{ mt: 1 }}>
        <Grid item xs={12} sm={4}>
          <TextField
            type="number"
            value={data?.marks || ""}
            onChange={(e) => handleChange("marks", Number(e.target.value))}
            label="Total Marks"
            size="small"
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            type="number"
            value={data?.choiceCount || ""}
            onChange={(e) =>
              handleChange("choiceCount", Number(e.target.value))
            }
            label="Choice Count"
            size="small"
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            value="Paper"
            label="Node Type"
            size="small"
            fullWidth
            disabled
          />
        </Grid>
      </Grid>
    </Paper>
  );
}

export default PaperForm;
